import React, { Component, Fragment } from 'react';
import Navbar from '../components/Navbar';
import Breadcrumbs from '../components/Breadcrumbs';
import Image from '../components/Image';

export default class Page extends Component {
  render() {
    return (
      <Fragment>
        <title>PropertyHints: Steps to buy a house</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <Breadcrumbs crumbs={[{ url: '/steps-to-buy', name: 'Steps to buy' }]} />
                <h2 className="lead text-center">Steps to Buy a House</h2>
                <div className="col-sm-12 col-md-12" align="center">
                  <Image style={{ maxHeight: '200px' }} alt="Calculate" src="/assets/images/HouseSmall.jpg" />
                  <hr />
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    <h3>1. Work out your budget</h3>
                    <p>
                      You need to work out what your budget will be. To do this you’ll need to get a realistic picture
                      of your finances, yay for budgeting
                    </p>
                    <p>Luckily there are lots of helpfull tools out there to help with this:</p>
                    <ul>
                      <li>
                        <a href="http://sorted.org.nz">sorted.org.nz</a>
                      </li>
                      <li>
                        <a href="http://familybudgeting.org.nz">familybudgeting.org.nz</a>
                      </li>
                      <li>
                        <a href="http://familyservices.govt.nz">familyservices.govt.nz</a>
                      </li>
                    </ul>
                    <p>
                      The main things you need to work out is how much are you earning each week/month, how much do you
                      have saved, how much do you have left over at the end of a week/month. This will help you work out
                      how much you can afford on a house. Also dont forget that if you are renting, you can take that
                      amount off of your weekly expenses and put it towards repayments.
                    </p>
                    <hr />
                    <h3>2. Get pre-approved for your loan</h3>
                    <Image style={{ maxHeight: '200px' }} alt="Calculate" src="/assets/images/loanSmall.jpg" />
                    <p>
                      Before you jump in and start looking at all of those lovelly houses out there, go get your loan
                      pre-approved so you know how much money you will actually be able to get.
                    </p>
                    <p>
                      An important thing to note about a pre approval is that all it really is, is a bank/financial
                      institution agreeing that if you apply for a mortgage, that they will offer you the amount you are
                      pre-approved for. You dont have to use it if you don't find a place you like.
                    </p>
                    <p>
                      The biggest piece of advice I can offer is to go talk to a Mortgage Broker. This is a{' '}
                      <strong>free</strong> service to you! We have been to both the{' '}
                      <a href="http://www.cab.org.nz/">Citizens Advice Beurau</a> and{' '}
                      <a href="http://homeloanshop.co.nz/">The Home Loan Shop</a>. Both of these places were amazing.
                      All we had to do was bring our documents in (identification, bank statements, and pay slips) and
                      they handled all of the work of going to the banks to see what offers they would give us. Two days
                      later we had pre-approval from a few banks. They also handle reapproving your pre-approval as it
                      expires every 60 days or so.
                    </p>
                    <p>
                      In these pre-approvals will be the amount they will offer you, the interest rate they would
                      charge, as well as any conditions the bank has. These conditions will be things like; You must get
                      a house valuation before settlement, you must get insurance on the house. We will come back to
                      purchase conditions later and cover it some more.{' '}
                    </p>
                    <hr />
                    <h3>3. Find a solicitor</h3>
                    <p>
                      Next is the fun part, you need a lawyer. Your lawyer will make sure that all the legal processes
                      are followed and they can also check over property reports, such as Land Information Memorandums
                      (Council LIM reports) and titles. They will also help you put together the purchase agreement when
                      you are ready to put an offer in on a house
                    </p>
                    <p>
                      Now for the pricing. Lawyers have a lot of pricing structures for this sort of thing. seen people
                      who didnt have to pay anything until they finally had an offer accepted, or some will charge for
                      the work of putting an offer together.
                    </p>
                    <p>
                      If you go through a Mortgage Broker, they will usually have a partnership with a few Law Firms
                      that they can recomment, otherwise just jump on the internet and find a firm with good reviews. If
                      you are like us and end up looking for a while, you will be working with your lawyer for a fair
                      bit.
                    </p>

                    <h3>4. Finding your house, the hunt begins</h3>
                    <Image
                      style={{ maxHeight: '200px' }}
                      alt="Calculate"
                      src="/assets/images/neighbourhood_small.jpg"
                    />
                    <p>
                      Everyone has their own way of searching, whether it be online, using an app or contacting a
                      salesperson.
                    </p>
                    <p>
                      For us we mostly went the online route, using{' '}
                      <a href="http://www.trademe.co.nz/property">Trademe</a> and{' '}
                      <a href="http://www.realestate.co.nz/">Realestate.co.nz</a> as we found almost all of the
                      properties around appeared on these.
                    </p>
                    <p>The other useful tools we used were:</p>
                    <ul>
                      <li>
                        <a href="http://www.trademe.co.nz/mobile/">The Trademe Property Phone App</a>
                      </li>
                      <li>
                        <a href="https://homes.co.nz/">Homes.co.nz</a> for up to date information on houses, and house
                        prices
                      </li>
                      <li>
                        <a href="https://www.trademe.co.nz/property/insights">Trademe Property Insights</a> for up to
                        date information on houses, and house prices
                      </li>
                    </ul>
                    <p>
                      If you are lucky the people selling the house will have ordered a lim report and builders report
                      already, this saves you the cost of doing it yourself (around $400-$600). Although take the
                      builders report with a grain of salt, as it was created for the owners and so may be a bit biased,
                      or miss something important.
                    </p>
                    <p>
                      It is also important to look over all of the other documentation you can find for the house Do
                      your due diligence, as if you miss something, it will likely be on you
                    </p>

                    <h3>5. Making your offer</h3>
                    <p>Woo, you have found a place you like enough to throw down some money!</p>
                    <p>
                      Next step is to get in touch with your Mortgage Broker and Lawyer to let them know about the
                      property and intentions. This allows them to get started on the purchase process from their end.
                      Once you get the Purchase agreement from the sellers and give it to your lawyer they can start to
                      fill it in and add any conditions you may have
                    </p>
                    <p>
                      Finally it will end up back with you, and you will need to do some signing, and add the all
                      important $ amount you want to offer (at this stage we always sent it back to the lawyer to do a
                      final check as it is a legally binding contract)
                    </p>
                    <p>
                      Then you can send it through to the seller of the house. Often they will ask for a deposit
                      (usually 10-20%), but we found that all you really need to do is add to your contract a note. It
                      would say something like "we agree to transfer x% deposit within one working day of the purchase
                      agreement being accepted" (when the sellers accept your offer). This saves the effort of having to
                      get bank checks created and then cancelling them if you dont get your offer accepted.
                    </p>

                    <h3>6. When your offer is accepted/declined</h3>
                    <p>
                      So if your offer is declined, the seller will usually contact you to let you know that you weren't
                      successfull. At this stage your purchase agreement is cancelled and you are legally free to go
                      offer on other properties
                    </p>

                    <p>
                      If in the happy case that you get your offer accepted, you will have x days to fulfil any
                      conditions you put on your offer. You will also be able to go to your bank to get your official
                      Mortgage offer. At that point your offer becomes unconditional and you will have another x days
                      (defined in your offer) to transfer the full purchase amount to the sellers lawyers. This is
                      something you don't want to be late on, as there are financial penalties. Also imporant to note is
                      that you can't pull out of the deal at this point without incuring some pretty hefty penalties,
                      unless there are some pretty special circumstances
                    </p>

                    <h3>7. You own a house, congratulations</h3>
                    <p>
                      On the settlement day, you will take ownership of the house and get your keys. Before this day
                      make sure you have things like insurance sorted out as you will be the one who has to pay if
                      something goes wrong :)
                    </p>
                    <p>
                      Otherwise, enjoy your house, pay down that mortgage, and hopefully have a very prosperous future.
                    </p>
                    <Image style={{ maxHeight: '200px' }} alt="Calculate" src="/assets/images/keyhandover.jpg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/StepsToBuy.jsx